import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { trialLimitLines, trialFeaturePlanName } from 'src/utils/plan/plan-public-ladder';

import { RADIUS } from 'src/theme/ui-tokens';
import { TRIAL_DAYS } from 'src/constants/subscription-plans';

import { trackPublicCta } from 'src/sections/common/track-public-cta';
import { usePublicTrialHref } from 'src/sections/common/hooks/model/use-public-trial-href';

import { CM, SECTION_PX, SECTION_PY, PUBLIC_TEXT, PUBLIC_CTA_SX, PUBLIC_MAX_WIDTH, balancedChipGridSx } from '../constants/home-theme';

// ----------------------------------------------------------------------

/**
 * 랜딩 맨 아래 — 체험으로 잇는다.
 * 🔑 한도 칩은 줄마다 같은 수로 선다(`balancedChipGridSx`) — 한 줄 끝에 한두 개만 떨어지지 않는다.
 * 🚨 체험은 기능만 BRAND 와 같다 — 등록 칸과 Research·MCP 횟수는 따로 있다(`plan_trial`). 그 한도를 그대로 적는다(`trialLimitLines`).
 * ⛔ 요금 세부(「유료 플랜에서만」 같은 말)는 적지 않는다 — 그 안내는 요금 화면 몫이다.
 */
export function HomeCtaSection() {
  const trialLimits = trialLimitLines();
  const trialHref = usePublicTrialHref();

  return (
    <Box id="cta" data-section-id="cta" component="section" sx={{ px: SECTION_PX, py: SECTION_PY }}>
      <Box sx={{ maxWidth: PUBLIC_MAX_WIDTH, mx: 'auto', borderRadius: RADIUS.lg, bgcolor: CM.textDark, px: { xs: 3, md: 8 }, py: { xs: 6, md: 8 }, textAlign: 'center' }}>
        <Typography component="h2" sx={{ ...PUBLIC_TEXT.title, color: '#fff', mb: 2 }}>
          {TRIAL_DAYS}일 동안 직접 {'써\u00A0보고'} 정하세요
        </Typography>
        <Typography sx={{ ...PUBLIC_TEXT.lead, color: 'rgba(255,255,255,0.8)', maxWidth: 640, mx: 'auto', mb: 3 }}>
          카드 등록 없이 {trialFeaturePlanName()} 플랜 기능을 그대로 씁니다.
        </Typography>

        <Box sx={{ ...balancedChipGridSx(trialLimits.length, { xs: 2, md: 4 }), gap: 1, mx: 'auto', mb: 4 }}>
          {trialLimits.map((line) => (
            <Typography key={line} sx={{ fontSize: 13, fontWeight: 600, color: '#fff', border: '1px solid rgba(255,255,255,0.24)', borderRadius: RADIUS.pill, px: 1.5, py: 0.5 }}>
              {line}
            </Typography>
          ))}
        </Box>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center">
          <Button
            component={RouterLink}
            href={trialHref}
            onClick={() => trackPublicCta('home.cta.trial', '무료로 시작하기')}
            sx={{ ...PUBLIC_CTA_SX, color: '#fff', bgcolor: CM.primary, '&:hover': { bgcolor: CM.primaryDark } }}
          >
            무료로 시작하기
          </Button>
          <Button
            component={RouterLink}
            href={paths.subscription.plan}
            onClick={() => trackPublicCta('home.cta.pricing', '요금제 보기')}
            sx={{ ...PUBLIC_CTA_SX, color: '#fff', border: '1px solid rgba(255,255,255,0.32)', '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' } }}
          >
            요금제 보기
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
